import React, {useState, useCallback, useEffect} from 'react';
import {useLocation, useNavigate} from "react-router-dom";

function TabsF({children}) {
    const route = useLocation()
    const {pathname}=route
    const navigate = useNavigate()

    const tabs = React.Children.toArray(children).filter(Boolean).map(child => (

        <div onClick={e => {
            e.preventDefault()
            navigate(`./${child.props.label}`)
        }}
             className={`flex items-center justify-center py-2 px-3 cursor-pointer whitespace-nowrap rounded transition-colors text-sm ${pathname.includes(child.props.label) ? 'text-gray-700 bg-gray-100' : 'text-gray-500 hover:bg-gray-100'}`}
             key={child.props.label}>
            {child.props.tabName}
        </div>
    ))

    return (
        <div className='flex items-center gap-1'>{tabs}</div>
    )
}

function TabF(props) {
    return <>{props.children}</>
}

export {TabsF, TabF}